import { useState } from "react";
import iconExpand from "images/iconExpand.svg";
import "./select.scss";
import { useField, useFormikContext } from "formik";

const Select = ({
  options,
  selected,
  ...props
}) => {
  const [selectedItem, setSelectedItem] = useState(selected)
  const [isOpened, setIsOpened] = useState(false)

  const { setFieldTouched, setFieldValue } = useFormikContext()
  const [field, meta] = useField(props)

  return (
    <>
      <div className="position-relative" tabIndex={0} onBlur={() => {
        setTimeout(() => {
          setIsOpened(false)
        }, 200)
      }}>
        <div className="select-container d-flex justify-content-between align-items-center" onClick={() => {
          setFieldTouched(field.name, true)
          setIsOpened(!isOpened)
        }}>
          <p className="m-0">
            {selectedItem}
          </p>
          <img
            src={iconExpand}
            className={isOpened ? "iconExpand_rotated" : "iconExpand"}
            alt=""
            onClick={() => setIsOpened(!isOpened)}
          />
        </div>
        {
          isOpened
            ? <ul className="select-list">
              {Object.keys(options).map(key => (
                <li
                  key={key}
                  onClick={() => {
                    setFieldTouched(field.name, true)
                    setSelectedItem(options[key])
                    setFieldValue(field.name, key)
                    setIsOpened(false)
                  }}
                >
                  {options[key]}
                </li>
              ))
              }
            </ul>
            : null
        }
      </div>
      {meta.touched && meta.error ? <div className="select-error">{meta.error}</div> : null}
    </>
  )
}

export default Select;